module.exports = __webpack_public_path__ + "static/media/RM.c8945249.pdf";